import React from "react";
import '../../CSS/Obras.css'
import { Button, CloseButton, Modal } from "react-bootstrap";

const ResumenProyecto = ({show, handleClose,nombre,total}) => {
    const proyecto = nombre;
    const totalMO = total.length === 0? 0:total[0].manoObra;
    const totalAdi = total.length === 0? 0:total[0].adicional;
    const totalMaq = total.length === 0? 0:total[0].maquinaria;
    const totalTra = total.length === 0? 0:total[0].tramites;
    const totalMat = total.length === 0? 0:total[0].materiales;
    const ingresos = total.length === 0? 0:total[0].ingresos;

    const totalFinal = totalMO + totalAdi + totalMaq + totalTra + totalMat;
    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const manoTotal = formato(totalMO)
    const adiTotal = formato(totalAdi)
    const maqTotal = formato(totalMaq)
    const traTotal = formato(totalTra)
    const matTotal = formato(totalMat)
    const finalTotal = formato(totalFinal)
    const ingresoFormat = formato(ingresos)
    const diferencia = ingresos-totalFinal  
    const diferenciaFormat = formato(diferencia)

    const getColor = (diferencia) => {
        if (diferencia < 0) return '#F92020';
        if (diferencia > 0) return '#59B67D';
        return '';
    };

    return (
        <Modal show={show} onHide={handleClose}  id="modal-resumen-proyecto" >
            <Modal.Header className=' btncolor'>
                <Modal.Title>INGRESOS Y EGRESOS</Modal.Title>
                <CloseButton onClick={handleClose} style={{backgroundColor:"white"}} />
            </Modal.Header>
            <Modal.Body  style={{textAlign:'right', marginTop:'15px', height:'60vh', overflowY:"scroll"}}>
                <div className="mb-3" style={{textAlign:'center'}}>
                    <h5 className="modal-title text-uppercase" id="exampleModalLabel">{proyecto}</h5>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">INGRESOS</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {ingresoFormat === null || ingresoFormat ==="NaN" ? (0):(ingresoFormat)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">EGRESOS</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {finalTotal === 'NaN' || finalTotal === null ? (0):(finalTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col" >
                        <label htmlFor="exampleFormControlInput1" className="form-label">TOTAL</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" style={{color:getColor(diferencia)}} className="form-label">
                            <strong>
                                $ {diferenciaFormat === null || diferenciaFormat ==="NaN" ? (0):(diferenciaFormat)}
                            </strong>
                        </label>
                    </div>
                </div> 
                <hr/>
                <div className="mb-3" style={{textAlign:'center'}}>
                    <h5 className="modal-title text-uppercase" id="exampleModalLabel">RESUMEN DE GASTOS</h5>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">MATERIALES</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {matTotal === 0 ? (0):(matTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">MANO DE OBRA</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {manoTotal === 0 ? (0):(manoTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">ADICIONALES</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {adiTotal === 0 ? (0):(adiTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">MAQUINARIA</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {maqTotal === 0 ? (0):(maqTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">TRAMITES</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {traTotal === 0 ? (0):(traTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col" >
                        <label htmlFor="exampleFormControlInput1" className="form-label">TOTAL</label>
                    </div>
                    <div className="col">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            <strong>
                                $ {finalTotal === 'NaN' ? (0):(finalTotal)}
                            </strong>
                        </label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button type="button" className="btn btncolor" onClick={handleClose}>CERRAR</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ResumenProyecto;